import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { formatedCvData } from "../../../../utils/types";

interface cvprops {
    onSubmitJson : (data : formatedCvData) => void;
}

const CvJson : React.FC<cvprops> = ({onSubmitJson}) => {
    const [cvJsontxt, setCvJsontxt] = useState<string>('');
    const [errMsg, setErrMsg] = useState<string>('');

    const processJson = () => {
        if(cvJsontxt === '') return setErrMsg('JSON field is empty');

        try{
            const processedJson = JSON.parse(cvJsontxt) as formatedCvData;
            onSubmitJson(processedJson);
        }catch(e){
            setErrMsg('Failed to process JSON text.');
        }
    }

    return(
        <div className="my-4">
            <div className="my-1">
                <h1>
                    ChatGPT JSON response: &nbsp;
                    <i className="text-red-500">{errMsg}</i>
                </h1>
            </div>
            <div>
                <textarea
                    onChange={(e) => setCvJsontxt(e.target.value)}
                    value={cvJsontxt}
                    id="textArea"
                    className="text-box min-w-[38rem] max-w-full max-h-full min-h-56 outline-none p-2" 
                />
            </div>
            <div className="flex justify-end my-2">
                <button type="button" onClick={()=>processJson()} className="button button-vcc-green text-sm w-fit">
                    <FontAwesomeIcon icon={faFloppyDisk} /> &nbsp;
                    Save JSON
                </button>
            </div>
        </div>
    )
}

export default CvJson;